/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDesignArtifactReviewDto } from "../models/AjaxResponseOfDesignArtifactReviewDto";
import type { AjaxResponseOfDesignRequestDto } from "../models/AjaxResponseOfDesignRequestDto";
import type { AjaxResponseOfDesignRequestPublicationsOutput } from "../models/AjaxResponseOfDesignRequestPublicationsOutput";
import type { AjaxResponseOfFacebookConnectionStatusOutput } from "../models/AjaxResponseOfFacebookConnectionStatusOutput";
import type { AjaxResponseOfListOfAvailableTemplateDto } from "../models/AjaxResponseOfListOfAvailableTemplateDto";
import type { AjaxResponseOfListOfDesignRequestDownloadDto } from "../models/AjaxResponseOfListOfDesignRequestDownloadDto";
import type { AjaxResponseOfListOfPlatformsVehicleDetails } from "../models/AjaxResponseOfListOfPlatformsVehicleDetails";
import type { AjaxResponseOfPagedResultDtoOfDesignRequestDto } from "../models/AjaxResponseOfPagedResultDtoOfDesignRequestDto";
import type { AjaxResponseOfPublishDesignRequestOutput } from "../models/AjaxResponseOfPublishDesignRequestOutput";
import type { AjaxResponseOfTikTokConnectionStatusOutput } from "../models/AjaxResponseOfTikTokConnectionStatusOutput";
import type { AjaxResponseOfTikTokPublishContextOutput } from "../models/AjaxResponseOfTikTokPublishContextOutput";
import type { CreateDesignRequestDto } from "../models/CreateDesignRequestDto";
import type { DesignRequestStatus } from "../models/DesignRequestStatus";
import type { DesignRequestType } from "../models/DesignRequestType";
import type { PublishDesignRequestInput } from "../models/PublishDesignRequestInput";
import type { RetryDesignRequestPublicationsInput } from "../models/RetryDesignRequestPublicationsInput";
import type { UpdateProviderPublishIdInput } from "../models/UpdateProviderPublishIdInput";
import type { UpdateRenderUrlInput } from "../models/UpdateRenderUrlInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class DesignRequestAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedResultDtoOfDesignRequestDto Success
   * @throws ApiError
   */
  public getAll({
    status,
    type,
    search,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    status?: DesignRequestStatus;
    type?: DesignRequestType;
    search?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests",
      query: {
        status: status,
        type: type,
        search: search,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public create({
    idempotencyKey,
    requestBody,
  }: {
    idempotencyKey: string;
    requestBody?: CreateDesignRequestDto;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests",
      headers: {
        "Idempotency-Key": idempotencyKey,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
        503: `Server Error`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPublishDesignRequestOutput Success
   * @throws ApiError
   */
  public notifyCompletion(): CancelablePromise<AjaxResponseOfPublishDesignRequestOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/notify-completion",
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public updateProviderPublishId({
    requestBody,
  }: {
    requestBody?: UpdateProviderPublishIdInput;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/design-requests/results/provider-publish-id",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public updateRenderUrl({
    resultId,
    requestBody,
  }: {
    resultId: number;
    requestBody?: UpdateRenderUrlInput;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/design-requests/results/{resultId}/render-url",
      path: {
        resultId: resultId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfPlatformsVehicleDetails Success
   * @throws ApiError
   */
  public getStock(): CancelablePromise<AjaxResponseOfListOfPlatformsVehicleDetails> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/stock",
    });
  }
  /**
   * @returns AjaxResponseOfListOfAvailableTemplateDto Success
   * @throws ApiError
   */
  public getAvailableTemplates({
    templateType,
    postType,
    socialMediaName,
  }: {
    templateType?: string;
    postType?: string;
    socialMediaName?: string;
  }): CancelablePromise<AjaxResponseOfListOfAvailableTemplateDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/templates",
      query: {
        templateType: templateType,
        postType: postType,
        socialMediaName: socialMediaName,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public delete({ id }: { id: number }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/design-requests/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public get({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public complete({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/complete",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfDesignRequestDownloadDto Success
   * @throws ApiError
   */
  public getDownloadLinks({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfListOfDesignRequestDownloadDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/{id}/downloads",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPublishDesignRequestOutput Success
   * @throws ApiError
   */
  public publish({
    id,
    requestBody,
  }: {
    id: number;
    requestBody?: PublishDesignRequestInput;
  }): CancelablePromise<AjaxResponseOfPublishDesignRequestOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/publish",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public refresh({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/refresh",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public rerender({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/rerender",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public refuse({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/refuse",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfTikTokPublishContextOutput Success
   * @throws ApiError
   */
  public getTikTokPublishContext({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfTikTokPublishContextOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/{id}/tiktok/publish-context",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestPublicationsOutput Success
   * @throws ApiError
   */
  public getPublications({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestPublicationsOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/{id}/publications",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPublishDesignRequestOutput Success
   * @throws ApiError
   */
  public retryPublications({
    id,
    requestBody,
  }: {
    id: number;
    requestBody?: RetryDesignRequestPublicationsInput;
  }): CancelablePromise<AjaxResponseOfPublishDesignRequestOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/publications/retry",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfTikTokConnectionStatusOutput Success
   * @throws ApiError
   */
  public getTikTokConnectionStatus(): CancelablePromise<AjaxResponseOfTikTokConnectionStatusOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/tiktok/connection-status",
    });
  }
  /**
   * @returns AjaxResponseOfFacebookConnectionStatusOutput Success
   * @throws ApiError
   */
  public getFacebookConnectionStatus(): CancelablePromise<AjaxResponseOfFacebookConnectionStatusOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/facebook/connection-status",
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestDto Success
   * @throws ApiError
   */
  public syncRenders({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design-requests/{id}/sync-renders",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignArtifactReviewDto Success
   * @throws ApiError
   */
  public getArtifactReview({
    artifactId,
  }: {
    artifactId: string;
  }): CancelablePromise<AjaxResponseOfDesignArtifactReviewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/artifacts/{artifactId}/review",
      path: {
        artifactId: artifactId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfDesignArtifactReviewDto Success
   * @throws ApiError
   */
  public getResultEditor({
    resultId,
  }: {
    resultId: number;
  }): CancelablePromise<AjaxResponseOfDesignArtifactReviewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design-requests/results/{resultId}/editor",
      path: {
        resultId: resultId,
      },
    });
  }
}
